module.exports = __webpack_public_path__ + "static/media/cross-grey.013ff99a.svg";